"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAfterRevisionFailure = exports.fetchAfterRevisionSuccess = exports.fetchAfterRevisionRequest = exports.fetchBeforeRevisionFailure = exports.fetchBeforeRevisionSuccess = exports.fetchBeforeRevisionRequest = exports.GeneratePreviewActions = exports.FolderTreeActions = void 0;
const ActionTypes = require("../../actionTypes/compare");
const _FolderTreeActions = require("../../modules/files/tree/actions");
const _GeneratePreviewActions = require("../../modules/files/generatePreview/actions");
exports.FolderTreeActions = _FolderTreeActions.default('congrid');
exports.GeneratePreviewActions = _GeneratePreviewActions.default('compare');
function fetchBeforeRevisionRequest(revisionUuid) {
    return {
        type: ActionTypes.FETCH_BEFORE_REVISION_REQUEST,
        payload: {
            revisionUuid
        }
    };
}
exports.fetchBeforeRevisionRequest = fetchBeforeRevisionRequest;
function fetchBeforeRevisionSuccess(payload) {
    return {
        type: ActionTypes.FETCH_BEFORE_REVISION_SUCCESS,
        payload
    };
}
exports.fetchBeforeRevisionSuccess = fetchBeforeRevisionSuccess;
function fetchBeforeRevisionFailure(payload) {
    return {
        type: ActionTypes.FETCH_BEFORE_REVISION_FAILURE,
        payload
    };
}
exports.fetchBeforeRevisionFailure = fetchBeforeRevisionFailure;
function fetchAfterRevisionRequest(revisionUuid) {
    return {
        type: ActionTypes.FETCH_AFTER_REVISION_REQUEST,
        payload: {
            revisionUuid
        }
    };
}
exports.fetchAfterRevisionRequest = fetchAfterRevisionRequest;
function fetchAfterRevisionSuccess(payload) {
    return {
        type: ActionTypes.FETCH_AFTER_REVISION_SUCCESS,
        payload
    };
}
exports.fetchAfterRevisionSuccess = fetchAfterRevisionSuccess;
function fetchAfterRevisionFailure(payload) {
    return {
        type: ActionTypes.FETCH_AFTER_REVISION_FAILURE,
        payload
    };
}
exports.fetchAfterRevisionFailure = fetchAfterRevisionFailure;
//# sourceMappingURL=index.js.map